// extracted by mini-css-extract-plugin
module.exports = {"area":"HalfDivideArea_area__YTs65","partsFirst":"HalfDivideArea_partsFirst__29tVd","partsSecond":"HalfDivideArea_partsSecond__1stF9"};